<template>
  <svg
    width="432"
    height="432"
    viewBox="0 0 432 432"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M349.961 0H82.0388C36.73 0 0 36.73 0 82.0388V349.961C0 395.27 36.73 432 82.0388 432H349.961C395.27 432 432 395.27 432 349.961V82.0388C432 36.73 395.27 0 349.961 0Z"
      fill="#0D0D0D"
    />
    <g clip-path="url(#clip0_4773_18178)">
      <path d="M121.685 259.662V284.897H63V146.103H96.5342V259.662H121.685Z" fill="#F2F2F2" />
      <path
        d="M192.421 153.148C186.448 147.049 177.959 144 166.746 144C155.533 144 147.045 147.049 141.072 153.148C135.098 159.246 132.164 167.868 132.164 178.909V251.986C132.164 263.132 135.098 271.754 141.072 277.852C147.045 283.951 155.533 287 166.746 287C177.959 287 186.448 283.951 192.421 277.852C198.394 271.754 201.328 263.132 201.328 251.986V178.909C201.328 167.763 198.394 159.141 192.421 153.043V153.148ZM171.986 254.404C171.986 257.349 169.68 259.662 166.746 259.662C163.812 259.662 161.507 257.349 161.507 254.404V176.596C161.507 173.651 163.812 171.338 166.746 171.338C169.68 171.338 171.986 173.651 171.986 176.596V254.404Z"
        fill="#F2F2F2"
      />
      <path
        d="M274.161 153.148C268.188 147.049 259.699 144 248.486 144C237.273 144 228.785 147.049 222.812 153.148C216.839 159.246 213.904 167.868 213.904 178.909V251.986C213.904 263.132 216.839 271.754 222.812 277.852C228.785 283.951 237.273 287 248.486 287C259.699 287 268.188 283.951 274.161 277.852C280.03 271.754 283.069 263.132 283.069 251.986V178.909C283.069 167.763 280.134 159.141 274.161 153.043V153.148ZM253.726 254.404C253.726 257.349 251.421 259.662 248.486 259.662C245.552 259.662 243.247 257.349 243.247 254.404V176.596C243.247 173.651 245.552 171.338 248.486 171.338C251.421 171.338 253.726 173.651 253.726 176.596V254.404Z"
        fill="#F2F2F2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M341.545 207.403L368.791 149.047C369.42 147.68 368.372 145.998 366.905 145.998H339.658C338.506 145.998 337.562 146.944 337.562 148.1V206.457C337.562 208.77 340.602 209.401 341.545 207.298V207.403Z"
        fill="#6BF218"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M369.001 284.897L329.179 210.243V146.103H295.645V284.897H329.179V265.235L339.658 284.897H369.001Z"
        fill="#F2F2F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_4773_18178">
        <rect width="306" height="143" fill="white" transform="translate(63 144)" />
      </clipPath>
    </defs>
  </svg>
</template>
